import { render } from "./ObjectInputSelect.vue?vue&type=template&id=3c975aa5&scoped=true"
import script from "./ObjectInputSelect.vue?vue&type=script&lang=js"
export * from "./ObjectInputSelect.vue?vue&type=script&lang=js"

import "./ObjectInputSelect.vue?vue&type=style&index=0&id=3c975aa5&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c975aa5"]])

export default __exports__